import { H2 } from '../../config/designSystem/typography';
import { Linking, View } from 'react-native';
import { TwoButtonsVertical } from '../../components/Button/TwoButtonsVertical';
import { concatPath } from '../../utils/links/concatPath';
import { isWeb } from '../../config/designSystem/Layout';
import { loginKey } from '../../constants/routeKeys';
import { observer } from 'mobx-react';
import { router } from 'expo-router';
import { useAvailableDimensions } from '../../hooks/ui/useAvailableDimensions';
import { useStores } from '../../hooks/useStores';

interface ContactProps { }


const Contact: React.FunctionComponent<ContactProps> = observer(() => {
  const rootStore = useStores();
  const { width } = useAvailableDimensions();
  const MARGIN_HORIZONTAL = 25;
  const WIDTH = Math.max(100, Math.min(800, width)) - 2 * MARGIN_HORIZONTAL;
  const labels = rootStore?.language.translate.MOBILE.CONTACT;
  const mailTo = labels?.EMAIL_TO ? labels?.EMAIL_TO : 'matthieu.gilson@evoluno.com';
  const JUSTIFY_CONTENT = isWeb ? 'flex-start' : 'space-between';

  const goToLogin = () => {
    router.navigate(concatPath([ loginKey], 0) as string);
  };



  return (
    <View style={{ alignItems: 'center', flex: 1, justifyContent: JUSTIFY_CONTENT, backgroundColor:'white' }}>
      <View style={{ maxWidth: WIDTH, marginHorizontal: MARGIN_HORIZONTAL, justifyContent: 'center', flex: 1, marginTop: 30 }}>
        <H2>
          {labels?.MAIN_TEXT ? labels?.MAIN_TEXT : 'Issue registering or loging in the application?'}
        </H2>
      </View>
      <TwoButtonsVertical

        onPressTop={() => {
          Linking.openURL('mailto:' + mailTo);
        }}

        onPressBelow= {() => {
          if(router.canGoBack()){
            router.back();
          } else {
            goToLogin();
          }
        }}

        labelTop={labels?.EMAIL ? labels?.EMAIL : 'Send email'}

        labelBelow={labels?.BACK_BUTTON
          ? labels?.BACK_BUTTON
          : 'Go back to login'}
      />

    </View>

  );
});


export default Contact;
